import { env } from '@/app/config/env';

const DEFAULT_WHATSAPP_WS_URL =
  'wss://whatsappapistaging.pro20officialapi01.it/api/v1/ws/messages';

function resolveWebSocketBase(): string {
  const fromEnv = env.WHATSAPP_WS_URL.trim();

  if (!fromEnv) {
    return DEFAULT_WHATSAPP_WS_URL;
  }

  return fromEnv
    .replace(/^https:/i, 'wss:')
    .replace(/^http:/i, 'ws:')
    .replace(/\/$/, '');
}

/**
 * WebSocket URL — auth via `token` query param (same as proventi-app).
 */
export function buildWahaWebSocketUrl(args: {
  token: string;
  branchCode: string;
  locale: string;
}): string {
  const params = new URLSearchParams({
    token: args.token.trim(),
    branch_code: args.branchCode.trim(),
    locale: args.locale.split('-')[0] || 'en',
  });

  return `${resolveWebSocketBase()}?${params.toString()}`;
}
